import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import  './RechartsReset.css';

const MyLine = ({ data, xLabel = {key: "x", label: ""},  yLabel = {key: "y", label: ""}, colors = ["#7A9A01", "#004851", "#E03C31", "#c09a00", "#F0F"] }) => {

    const dataKeys = [...new Set(data.flatMap(Object.keys).filter(key => key !== xLabel.key))];

    return (
        <ResponsiveContainer width={"100%"} height={300}>
            <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey={xLabel.key} label={{ value: xLabel.label, position: 'insideBottomRight', offset: 0, style: { transform: 'translate(-10px, 10px)' } }} />
                <YAxis label={{ value: 'Inscrits', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Legend verticalAlign="bottom" align="center" wrapperStyle={{ position: 'relative', top: 0 }} />
                {dataKeys.map((key, index) => (
                    <Line
                        key={key}
                        type="monotone"
                        dataKey={key}
                        stroke={colors[index % colors.length]}
                        strokeWidth={3}
                        activeDot={{ r: 8 }}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
};

export default MyLine;
